import { render, staticRenderFns } from "./FaqHomeOne.vue?vue&type=template&id=6ecc4f97&"
import script from "./FaqHomeOne.vue?vue&type=script&lang=js&"
export * from "./FaqHomeOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports